// Returns a flat array for signals
// Input
// [
//   {
//     signalNameId: 'xyz',
//     newsList: [
//       {
//         ...newsObjectData
//       }
//     ]
//   }
// ]
// Output
// [
//   {
//     ...newsObj,
//     signalNameId: 'xyz'
//   }
// ]

export default (data) =>
    data.reduce((acc, val) => {
        return [
            ...acc,
            ...val.newsList.map((n) => ({
                ...n,
                signalNameId: val.signalNameId,
            })),
        ];
    }, []);
